import {css} from 'lit'; export default css`.simple-search-container{display:flex;gap:.2rem;align-items:center}.simple-search-container>search-field-with-suggestions{flex:1}`;
    